import type { AcademicOverviewInsights } from '../types';
import { adaptExecutive } from './adaptExecutive';
import { ExecutiveOverviewPanel } from './ExecutiveOverviewPanel';
import { LegacyOverviewPanel } from './LegacyOverviewPanel';

/**
 * DEAN, HEAD OF DEPARTMENT, PRINCIPAL, DIRECTOR — the academic state of the school.
 *
 * TWO COMPOSITIONS, ONE SCOPE, AND THE PAYLOAD DECIDES. EduCore and this console
 * deploy independently, so the executive contract (population, staffing, academics,
 * finance, attention, …) is optional on every field. A payload carrying any of it
 * gets the command-centre composition; a payload from an EduCore that predates it
 * gets exactly the panel that shipped before — not a hybrid with holes.
 *
 * `admissionsFunnel` and `boarding` count as executive signals even when null:
 * null is a server that KNOWS the capability and says it is off, which only the
 * new contract can say at all.
 */
export function AcademicOverviewPanel({
  data,
  locale,
  institutionId,
}: {
  data: AcademicOverviewInsights;
  locale: string;
  institutionId?: string;
}) {
  const adapted = adaptExecutive(data);
  const executive =
    adapted.population !== undefined ||
    adapted.staffing !== undefined ||
    adapted.academics !== undefined ||
    adapted.finance !== undefined ||
    adapted.attention !== undefined ||
    adapted.approvals !== undefined ||
    adapted.admissionsFunnel !== undefined ||
    adapted.boarding !== undefined ||
    adapted.attendance.today !== undefined ||
    adapted.asOf !== undefined;

  return executive ? (
    <ExecutiveOverviewPanel data={adapted} locale={locale} institutionId={institutionId} />
  ) : (
    <LegacyOverviewPanel data={adapted} locale={locale} institutionId={institutionId} />
  );
}
